import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_o9vyyir9zj: FaireBrandEntity = {
  token: "b_o9vyyir9zj",
  type: "brand",
  name: "Rustic Strength",
  avatarUrl:
    "https://cdn.faire.com/fastly/9aee4cf8dd53b451041fc31e4b96b3dd7d28407c4ffa43dc04ca0369565f599f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/652bc0d45bc4e94b31af6a604593a50c41c0da0149b994171527b6b7d0b28301.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9aee4cf8dd53b451041fc31e4b96b3dd7d28407c4ffa43dc04ca0369565f599f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/652bc0d45bc4e94b31af6a604593a50c41c0da0149b994171527b6b7d0b28301.jpeg",
  location: "Mansfield, MO, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 90,
  isTopShop: true,
  isInsider: true,
  description:
    'Rustic Strength manufactures high-purity, toxin-free refillable plant-based cleaning + wellness products. With hundreds of bulk refill locations from Hawaii to the East Coast, you can sustainably refill. \n\nMy husband and I started this company to reduce toxins in our own life. Now we help others do the same. The difference between our products vs. others on the market is that we use highly concentrated active ingredients that are sourced with no impurities. We strictly avoid harsh allergenic chemicals and the processes that produce known carcinogens and hormone disruption. Our products are all phthalate-free, paraben-free, phosphate-free, SLS-free, SLES-free, and what we like to say, "simply worry-free". \n\nWe didn’t sweat when New York recently placed restrictions on the sale of cleaning products containing high levels of the known carcinogen 1,4 Dioxane. Where many big brands fell short of the standard and lost public trust, we were able to gain it by not having this impurity.\n\nWe were the first manufacturer to implement a closed loop process. In our "Close The Loop Program", we wash and sanitize previously loved containers and send them back to customers. \n\nMost of our products are produced daily at our family-run factory in The Ozarks, USA — arriving to directly you made the same week. While with larger companies product may have sat on shelves for up to a year. \n\n-Alicia, Brandon, Devin, Dillon, Luke, Janel, Gary, & Chris',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:16.417Z",
    importedBy: "entity-db-cli",
  },
};
